import { decamelize } from 'humps';
import React, { useMemo } from 'react';
import { Link } from 'react-router';
import { useKPPanelContext } from '~/components/key-parameters/key-parameters-panel-v4/kp-panel-context';
import { otherWikiDetailRoute } from '~/paths';

type Props = {
  fieldName: string;
  children: React.ReactNode;
};

export function LinkedOtherValue({ fieldName, children }: Props) {
  const { otherWikiList } = useKPPanelContext();

  // Try to find a possible wiki page link by converting camel case title
  const possibleTitle = useMemo(() => {
    return decamelize(fieldName, { separator: ' ' }).trim().toLowerCase();
  }, [fieldName]);

  const wikiPage = otherWikiList.find(wp => {
    const matchableTitle = wp.title
      .replaceAll(/[^a-zA-Z\s]/g, '')
      .trim()
      .toLowerCase();

    return matchableTitle === possibleTitle;
  });

  if (!wikiPage) return <>{children}</>;

  return (
    <Link
      to={otherWikiDetailRoute(parseInt(wikiPage.id))}
      target="_blank"
      className="link"
    >
      {children}
    </Link>
  );
}
